import { updateUserRole } from "@/models/socket/admin.model";
import { Button } from "@/shadcn/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shadcn/components/ui/dialog";
import { genericSuccessToast } from "@/utils/utils.util";
import React, { useState } from "react";

type UserConfirmDialogProps = {
  userFullName: string;
  userID: string;
  updateRole: (userId: string, roleAction: "approve" | "admin") => void;
  onClose: () => void;
  newRole: "approve" | "admin";
};

const UserConfirmDialog: React.FC<UserConfirmDialogProps> = ({
  userFullName,
  userID,
  updateRole,
  onClose,
  newRole,
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  async function confirmUser() {
    setSubmitting(true);
    setError(null);
    const response = await updateUserRole(userID, newRole);
    if (response.rStatus === "error") {
      console.error("Failed to update user role:", response.rData);
      setError(response.rData);
      return;
    }

    genericSuccessToast(
      newRole === "approve"
        ? "User approved successfully"
        : "User promoted to admin successfully"
    );
    updateRole(userID, newRole); // update role in parent component
    setSubmitting(false);
    onClose(); // close dialog after successful update
    setError(null); // reset error state
  }

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) {
          setTimeout(() => {
            onClose(); // call onClose when dialog is closed
          }, 100); // reset state after dialog closes
        }
      }}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {newRole === "approve" ? "Approve" : "Promote to admin:"}{" "}
            {userFullName}
          </DialogTitle>
          <DialogDescription></DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <p>
            Are you sure you want to confirm {userFullName}? <br />
          </p>
          {error && <div className="text-sm text-red-500">{error}</div>}
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button className="" onClick={confirmUser} disabled={submitting}>
            {submitting ? "Submitting..." : "Confirm"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UserConfirmDialog;
